import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';

const SubscriptionContext = createContext(null);

export const useSubscription = () => useContext(SubscriptionContext);

export const SubscriptionProvider = ({ children }) => {
  const { api, user } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSubscription = useCallback(async () => {
    try {
      const res = await api.get('/user/subscription');
      setSubscription(res.data);
    } catch {
      setSubscription({ plan_id: 'starter', plan: { name: 'Starter', scans_limit: 5, campaigns_limit: 3, frameworks_limit: 2, users_limit: 5, features: ['basis_dashboard', 'nulmeting', 'risicos'] }, usage: {}, locked_features: ['financieel', 'leveranciers', 'export_pdf', 'benchmarks', 'api_access', 'sso', 'audit_trail', 'custom_frameworks'] });
    } finally { setLoading(false); }
  }, [api]);

  useEffect(() => {
    if (user) fetchSubscription();
  }, [user, fetchSubscription]);

  const isFeatureLocked = (featureKey) => {
    if (!subscription) return false;
    return (subscription.locked_features || []).includes(featureKey);
  };

  const getUsage = (key) => {
    if (!subscription?.usage?.[key]) return { used: 0, limit: -1, percentage: 0 };
    const u = subscription.usage[key];
    return { ...u, percentage: u.limit > 0 ? Math.round((u.used / u.limit) * 100) : 0 };
  };

  const planName = subscription?.plan?.name || 'Starter';
  const planId = subscription?.plan_id || 'starter';

  return (
    <SubscriptionContext.Provider value={{ subscription, loading, isFeatureLocked, getUsage, planName, planId, refetch: fetchSubscription }}>
      {children}
    </SubscriptionContext.Provider>
  );
};
